<template>
  <div class="page-wrapper newslist-page">
    <div class="container">
      <Social />
      <a-row :gutter="[32, 32]">
        <a-col :lg="17">
          <div class="news-list-content">
            <h2 class="heading">
              <div class="page-title">Latest News</div>
            </h2>
            <a-list
              :grid="{ gutter: 16, xs: 1 }"
              :loading="newsLoading"
              :dataSource="news"
              :pagination="pagination"
              :key="1"
            >
              <a-list-item
                slot="renderItem"
                slot-scope="item"
                class="list-complete-item"
              >
                <NewsCard
                  :news="item"
                  :key="item.id"
                  @click="goToNewsDetail(item.id)"
                />
              </a-list-item>
            </a-list>
          </div>
        </a-col>
        <a-col :lg="7">
          <NewsSideBar
            @search="text => getNews({ page: currentPage, q: text })"
            @category-click="id => getNews({ page: currentPage, category: id })"
            @tag-click="id => getNews({ page: currentPage, tags: id })"
            :selected-category="category"
            :selected-tag="tag"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import NewsCard from "./card";
import NewsSideBar from "./sidebar";
import { mapGetters } from "vuex";
import Social from '@/pageComponents/social/Social'
import { Base } from "@/models";

const STORE_KEY = "newsStore";

export default {
  name: "NewsList",
  components: {
    NewsCard,
    NewsSideBar,
    Social
  },
  data() {
    return {
      currentPage: 1,
      searchQuery: "",
      category: null,
      tag: null
    };
  },
  computed: {
    ...mapGetters({
      news: `${STORE_KEY}/news`,
      newsLoading: `${STORE_KEY}/newsLoading`,
      newsMeta: `${STORE_KEY}/newsMeta`
    }),
    pagination() {
      return {
        onChange: page => {
          this.getNews({ page });
        },
        pageSize: 6,
        total: this.newsMeta.total || 1
      };
    }
  },
  mounted() {
    if (Object.keys(this.$route.query).length > 0) {
      this.category = this.$route.query.category_id;
      this.tag = this.$route.query.tag_id;
      this.searchQuery = this.$route.query.q;
    }
    this.getNews({
      category: this.category,
      tags: this.tag,
      q: this.searchQuery
    });
  },
  methods: {
    getNews({ page = 1, q = null, category = null, tags = null }) {
      this.currentPage = page;
      this.searchQuery = q;
      this.category = category;
      this.tag = tags;
      this.$store.dispatch(`${STORE_KEY}/getNews`, {
        limit: 6,
        page,
        searchField: "title",
        q: this.searchQuery,
        category: this.category,
        tags: this.tag,
        sort: "-createdAt"
      });
    },
    goToNewsDetail(id) {
      if (this.$route.params.profileId) {
        this.$router.push(`/${Base.profileId()}/news/${id}`);
        return;
      }
      this.$router.push(`/news/${id}`);
    }
  }
};
</script>
<style lang="scss">
.newslist-page {
  background: #f0f0f0;
  padding: 80px 0;
  .news-list-content {
    .heading {
      .page-title {
        width: fit-content;
        text-transform: uppercase;
        font-size: 20px;
        color: #4f5152;
        position: relative;
        padding-left: 20px;
        margin-bottom: 40px;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 5px;
          height: 100%;
          background: #d23129;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .newslist-page {
    .news-list-content {
      .ant-pagination {
        display: flex;
        justify-content: center;
      }
      .heading {
        .page-title {
          margin: 0 auto 40px;
        }
      }
    }
  }
}
</style>
